import { isTestsystem, API_BASE, TOKEN_KEY } from './config';

function handleAuth401() {
  localStorage.removeItem(TOKEN_KEY);
  window.location.href = isTestsystem ? '/testsystem/' : '/';
}

export const api = {
  async get(path: string, token?: string) {
    const res = await fetch(`${API_BASE}${path}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (res.status === 401) { handleAuth401(); return null; }
    const text = await res.text();
    if (!text) return null;
    try { return JSON.parse(text); } catch { return null; }
  },
  async post(path: string, body: unknown, token?: string) {
    const res = await fetch(`${API_BASE}${path}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(body),
    });
    if (res.status === 401) { handleAuth401(); return null; }
    const text = await res.text();
    if (!text) return null;
    try { return JSON.parse(text); } catch { return null; }
  },
};
